import "i18n";
import "index.scss";
import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { StoreProvider } from "easy-peasy";

import { store } from "api/client";
import Loader from "components/Loader";
const clientStore = store;
const LazyApp = lazy(() => import("App"));

const AppRoot = (
  <React.StrictMode>
    <StoreProvider store={clientStore}>
      <Suspense fallback={<Loader />}>
        <LazyApp />
      </Suspense>
    </StoreProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(AppRoot);

// ReactDOM.render(AppRoot, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
